import { render, staticRenderFns } from "./AdaButton.vue?vue&type=template&id=b3ae7f50&scoped=true"
import script from "./AdaButton.vue?vue&type=script&lang=js"
export * from "./AdaButton.vue?vue&type=script&lang=js"
import style0 from "./AdaButton.vue?vue&type=style&index=0&id=b3ae7f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae7f50",
  null
  
)

export default component.exports